const BaseComponent = require('base/base-component');
const Query = require('helper/query');
const Server = require('helper/server');
const AjaxTemplateSearch = require('common/ajax-template-search/extend');

const pdsTpl = Handlebars.templates['common/org-detail/templates/pds-list'];
const staffTpl = Handlebars.templates['common/org-detail/templates/staff-list'];
const performanceTpl = Handlebars.templates['common/org-detail/templates/performance-list'];
const qualificationTpl = Handlebars.templates['common/org-detail/templates/qualification-list'];
const pageTpl = Handlebars.templates['common/org-detail/templates/pageTpl'];

class OrgDetail extends BaseComponent {
  constructor () {
    super({
      events: {
        'error #basicInfo img': 'handleError',
        'click .Jsearch': 'searchList'
      }
    });
  }
  init () {
    this.query = new Query();
    this.$bread = this.$el.find('span.bread');
    this.$img = this.$el.find('#basicInfo img');
    this.$nopic = this.$el.find('#basicInfo .nopic');
    this.req = {
      '#pds': false,
      '#staff': false,
      '#performance': false,
      '#qualification': false
    };
    this.listenImgError(); // 监听图片报错
    if (this.query.get('supplierId')) {
      this.$el.find('.org-detail-content').html(pageTpl({
        _type: 'supplier'
      }));
      this.renderSupplierDetail();
    } else {
      this.$el.find('.org-detail-content').html(pageTpl({
        _type: 'agency'
      }));
      this.renderAgencyDetail();
    }
  }
  renderSupplierDetail () {
    const opts = {
      data: {
        supplierId: this.query.get('supplierId')
      }
    };
    // 供应商基本信息 & 供应商企业信息
    $.when(Server.getSupplierBaseInfo(opts), Server.getSupplierCompany(opts))
      .then(([data1], [data2]) => {
        for (let key in data2) {
          const { validtimeStart, validtimeEnd } = data2[key];
          if (validtimeStart !== undefined) {
            data2[key].indate = (validtimeStart && validtimeEnd) ? moment(validtimeStart).format('YYYY-MM-DD') + '~' + moment(validtimeEnd).format('YYYY-MM-DD') : '';
          }
        }
        const { bus = {}, tax, social, org } = data2;
        const { mainscope = '', sidescope = '' } = bus;
        data1.businessscope = (mainscope ? mainscope : '-' )+ ' ' + (sidescope ? sidescope : '-'); // 经营范围
        this.$bread.text(`供应商 > ${data1.name}`);
        fillText(this.$el.find('#basicInfo .detail,#info .detail'), data1);
        bus && fillText(this.$el.find('.companyInfo .detail'), bus);
        tax && fillText(this.$el.find('.taxInfo .detail'), tax);
        social && fillText(this.$el.find('.socialecurityInfo .detail'), social);
        org && fillText(this.$el.find('.orgInfo .detail'), org);
      });
    // 供应商法人信息
    Server.getSupplierLegalPerson(opts)
      .then((data) => {
        fillText(this.$el.find('#legal .detail'), data);
      });
    // 供应商特定资质、信用信息
    Server.getSupplierCertificates(opts)
      .then((data) => {
        const $qtbody = $('#qualification tbody'); // 特点资质
        const $ctbody = $('#credit tbody'); // 信用信息
        let str1 = '';
        let str2 = '';
        for (let i in data) {
          let item = data[i];
          if (item.topType === 'SPECIFIC') {
            str1 += '<tr><td>' + format(item.certificateTypeName) + '</td><td>' +
              format(item.certificateLevelName) + '</td><td>' + format(item.certificateCode) + '</td><td>' + format(item.validtimeStart) +
              '</td><td>' + format(item.validtimeEnd) + '</td><td>' + format(item.latestchecktime) +
              '</td><td>' + format(item.certificateOrgname) + '</td></tr>';
          } else {
            str2 += '<tr><td>' + format(item.certificateTypeName) + '</td><td>' +
              format(item.certificateLevelName) + '</td><td>' + format(item.certificateCode) + '</td><td>' + format(item.validtimeStart) +
              '</td><td>' + format(item.validtimeEnd) + '</td><td>' + format(item.latestchecktime) +
              '</td><td>' + format(item.certificateOrgname) + '</td></tr>';
          }
        }
        $qtbody.append(str1);
        $ctbody.append(str2);
        if ($qtbody.find('td').length == 0) {
          $qtbody.append('<tr><td style="text-align: center; color: #EDEDED;font-size: 36px;line-height: 100px;" colspan="7">暂无数据</td></tr>');
        }
        if ($ctbody.find('td').length == 0) {
          $ctbody.append('<tr><td style="text-align: center; color: #EDEDED;font-size: 36px;line-height: 100px;" colspan="7">暂无数据</td></tr>');
        }
      });
  }

  renderAgencyDetail () {
    const opts = {
      data: {
        orgId: this.query.get('orgId')
      }
    };
    Server.getAgencyBaseInfo(opts)
      .then((data) => {
        // 面包屑
        this.$bread.text(`代理机构 > ${data.fullName}`);
        // 业务范围
        data.businessScope = (data.aptitude.business.bizMainRange || '') + ' ' + (data.aptitude.business.bizConcurrentRange || '');
        // 机构logo图片
        if (!!data.fileVo && data.fileVo.downloadUrl) {
          data.logoImg = data.fileVo.downloadUrl;
        }
        fillText(this.$el.find('#basicInfo .detail,#info .detail'), $.extend(data, data.aptitude.business));
      });
  }

  searchList (e) {
    const root = $(e.currentTarget).data('target');
    const opts = {
      root,
      appendElem: 'tbody',
      paginationSelector: '.js-pagination',
      callback: () => {
        this.req[root] = true;
      }
    };
    /* eslint-disable */
    switch (root) {
      case '#pds':
        opts.ajaxUrl = '/api/core/remote/itemQuery';
        opts.template = pdsTpl;
        break;
      case '#staff':
        opts.ajaxUrl = '/api/core/remote/ageprofessionaList';
        opts.template = staffTpl;
        opts.extends = {
          qualifType: 'SPECIFIC'
        };
        break;
      case '#performance':
        opts.ajaxUrl = '/api/core/remote/ageperformanceList';
        opts.template = performanceTpl;
        opts.extends = {
          qualifType: 'SPECIFIC'
        };
        break;
      case '#qualification':
        opts.ajaxUrl = '/api/core/remote/agequalificationList';
        opts.template = qualificationTpl;
        opts.extends = {
          qualifType: 'SPECIFIC'
        };
        break;
    }
    /* eslint-enable */
    if (this.req[root]) {
      return;
    }
    new AjaxTemplateSearch(opts);
  }

  /**
   * 监听图片报错,由于error事件不冒泡，所用用捕获的方式绑定事件
   */
  listenImgError () {
    document.addEventListener('error', (e) => {
      const ele = e.target;
      if (ele.tagName.toLowerCase() === 'img') {
        ele.src = '/assets/images/common/org-logo-bg.png';
      }
    }, true);
  }
}
module.exports = OrgDetail;

function fillText (el, data) {
  let $el = null;
  if (el instanceof jQuery) {
    $el = el;
  } else {
    $el = $(el);
  }
  $el.each((i, item) => {
    const _n = $(item).attr('data-name');
    let _t = data[_n] || '';
    // 时间处理
    if (_t && (_n == 'gmtCreate' || _n == 'inceptionDate' || _n == 'latestchecktime')) {
      _t = moment(_t).format('YYYY-MM-DD');
    }
    if (item.tagName === 'IMG') {
      $(item).prop('src', _t || '/assets/images/common/org-logo-bg.png');
    } else if (item.tagName === 'A') {
      if (_t == null || _t == undefined || _t == '') {
        _t = 'javascript:void(0);'; // eslint-disable-line
      } else if (!/^\/\/|^http/.test(_t)) {
        _t = '//' + _t;
      }
      $(item).prop('href', _t);
    } else {
      $(item).text(_t);
    }
  });
}

function format (data) {
  return data || '';
}
